import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MenuItem } from '@shared/config/menu';
import { AccessOptions } from '@shared/models/accessOptions.model';
import { Formation } from '@shared/models/formation.model';
import { Personas } from '@shared/models/personas.model';
import { InstanceIdService } from '@shared/services/instance-id.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { TaskService } from '@shared/services/task.service';
import { normalizeUrl } from '@shared/utils/string-operations.functions';
import _ from 'lodash';
import { ScrollbarsAutoHideBehavior } from 'overlayscrollbars';
import { posthog } from 'posthog-js';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { HrsuiteService } from 'src/app/hrsuite/hrsuite.service';
import { UtilisService } from 'src/app/shared/services/utilis.service';
import { ICONSET } from 'src/themes/common/principal-theme';
import { ChatService } from '../core/services/chat.service';
import { ChatGlobalSocketService } from '../core/services/chatGlobalSocket.service';
import { NavigationService } from '../core/services/navigation.service';
import { StorageService } from '../core/services/storage.service';
import { AnnuairePopupComponent } from '../shared/components/annuaire-popup/annuaire-popup.component';
import { pages } from '../shared/config/pages';
import { Hospital } from '../shared/models/hospital.model';
import { User } from '../shared/models/user.model';
import { CalendarRequestService } from '../shared/services/calendar-request.service';
import { ErrorService } from '../shared/services/error.service';
import { HospitalService } from '../shared/services/hospital.service';
import { capitalize } from '../shared/utils/cross-functions';
// addDisplayNameToHospitals
import { NotificationsFeedComponent } from './../shared/components/notifications-feed/notifications-feed.component';
import { NotificationService } from './../shared/services/notification.service';
import { UserService } from './../shared/services/user.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  standalone: false,
})
export class SideNavComponent implements OnInit, AfterViewInit, OnDestroy {
  private instanceId: string;

  public rightClickedPage: any;

  public pages: MenuItem[] = [];

  public pagesConfig: MenuItem[] = [];

  public homePage: AccessOptions | undefined;

  public realHomePage: AccessOptions | undefined;

  public allPages = pages;

  public dynamicPages: string[] = [];

  public iconTheme = ICONSET;

  public unseenMessages: number = 0;

  public currentPage: string | undefined;

  public currentMenu: string | undefined;

  public currentUser: User | undefined;

  public currentUserImage: string | undefined;

  public isAnesth: boolean = false;

  public nursesFormations: string[] = [];

  public anesthsFormations: string[] = [];

  public iadesFormations: string[] = [];

  public cdbFormations: string[] = [];

  public surgeonsFormations: string[] = [];

  public counterFormations: string[] = [];

  public osComponentOptions = {
    className: 'os-theme-dark custom-sidebar',
    nativeScrollbarsOverlaid: {
      showNativeScrollbars: true,
    },
    overflowBehavior: {
      x: 'hidden',
    },
    paddingAbsolute: true,
    scrollbars: {
      autoHide: 'never' as ScrollbarsAutoHideBehavior,
      clickScrolling: true,
    },
  };

  @Input() public profilePic: string | undefined;

  @Output() public sidenavClose = new EventEmitter();

  @Output() public sidenavToggle = new EventEmitter();

  @Input() public isThereNewModifs: boolean = false;

  @Output() public saveAgendas = new EventEmitter<boolean>();

  @ViewChild('rightClickBtnContainer', { static: false }) private rightClickBtnContainer: ElementRef | undefined;

  private sideNavReduced = false;

  public currentUserName: string | undefined;

  public isMultiHospitals: boolean = false;

  public hospitals: any[] = [];

  public selectedHospitals: any;

  public selectedHospitalsName: string = '';

  public soloHospitalMode: boolean = false;

  public nbSelectedHospitals: number = 1;

  public notificationsCounter: number | undefined;

  public requestsCounter: number = 0;

  public surgeonRequestsCounter: number = 0;

  public initDone = false;

  public sectionRequestsCounter: string = '';

  public pageTitleRequestsCounter: string = '';

  public requestsCounterAccessOption: AccessOptions | undefined;

  public sectionSurgeonRequestsCounter: string = '';

  public pageTitleSurgeonRequestsCounter: string = '';

  public surgeonRequestsCounterAccessOption: AccessOptions | undefined;

  constructor(
    private readonly utilisService: UtilisService,
    private readonly notificationService: NotificationService,
    private readonly authenticationService: AuthenticationService,
    private readonly chatService: ChatService,
    private readonly chatGlobalSocket: ChatGlobalSocketService,
    private readonly storageService: StorageService,
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly navigationService: NavigationService,
    private readonly errorService: ErrorService,
    private readonly dialog: MatDialog,
    private readonly hospitalService: HospitalService,
    private readonly hrsuiteService: HrsuiteService,
    private readonly calendarRequestService: CalendarRequestService,
    private taskService: TaskService,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
    this.setMenuAccessOptions(true);
    this.toggleSideNav();
    this.subscriptionManager.createRequest(router.events, 'routerEvents', this.instanceId).subscribe({
      next: (event: any) => {
        if (event instanceof NavigationStart) {
          this.setCurrentPage(event.url);
        }

        if (event instanceof NavigationCancel) {
          this.setCurrentPage();
        }

        if (event instanceof NavigationEnd) {
          this.setCurrentPage();
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });

    this.subscribeToReloadActiveRequestsCounterSubject();
    this.subscribeTotoggleNightHRRequestsSubject();
    this.subscribeToRebuildMenuSubject();
  }

  isFichePosteActive(): boolean {
    const accessOptionsFichePoste = ((this.currentUser?.persona as Personas).accessOptions as AccessOptions[]).filter(
      (accessOption: AccessOptions) => accessOption.pageUrl?.includes('fiche-poste') && accessOption.displayInSideNav
    );

    if ((accessOptionsFichePoste ?? []).length > 1) {
      return this.router.url.includes('/configuration/advanced/fiche-poste') && !this.router.url.includes('individual');
    } else {
      return this.router.url.includes('/configuration/advanced/fiche-poste');
    }
  }

  isFichePosteItem(pageSub: any): boolean {
    return pageSub.link.includes('/configuration/advanced/fiche-poste');
  }

  isFichePosteIndividualActive(): boolean {
    return this.router.url.startsWith('/configuration/advanced/fiche-poste/individual');
  }

  subscribeToRebuildMenuSubject() {
    this.subscriptionManager
      .createRequest(this.userService.rebuildMenuSubject, 'rebuildMenu', this.instanceId)
      .subscribe({
        next: () => {
          this.setMenuAccessOptions();
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  setMenuAccessOptions(init: boolean = false) {
    this.pages = [];
    this.pagesConfig = [];

    const accessOptions = (
      (this.userService.getCurrentUser().persona as Personas).accessOptions as AccessOptions[]
    ).filter((accessOption: AccessOptions) => accessOption.displayInSideNav);
    this.homePage = ((this.userService.getCurrentUser().persona as Personas).accessOptions as AccessOptions[]).find(
      (accessOption: AccessOptions) => accessOption.pageUrl === '/pending-requests/home'
    );

    if (init) {
      this.realHomePage = (
        (this.userService.getCurrentUser().persona as Personas).accessOptions as AccessOptions[]
      ).find((accessOption: AccessOptions) => accessOption.isHome);

      if (this.realHomePage) {
        this.setCurrentPage(this.realHomePage.pageUrl);
      }
    }

    const accessOptionsMain = accessOptions
      .filter((accessOption: AccessOptions) => accessOption.menu === 'main' && accessOption !== this.homePage)
      .sort((a: AccessOptions, b: AccessOptions) => (a.prioritySection ?? 99) - (b.prioritySection ?? 99));
    const accessOptionsConfig = accessOptions
      .filter((accessOption: AccessOptions) => accessOption.menu === 'config' && accessOption !== this.homePage)
      .sort((a: AccessOptions, b: AccessOptions) => (a.prioritySection ?? 99) - (b.prioritySection ?? 99));

    this.requestsCounterAccessOption = accessOptionsMain.find((accessOption: AccessOptions) =>
      accessOption.pageUrl?.includes('/hrsuite/demande-rh')
    );

    this.sectionRequestsCounter = this.requestsCounterAccessOption?.section ?? '';
    this.pageTitleRequestsCounter = this.requestsCounterAccessOption?.pageTitle ?? '';

    this.surgeonRequestsCounterAccessOption = accessOptionsMain.find((accessOption: AccessOptions) =>
      accessOption.pageUrl?.includes('/operatingschedule/demande-rh')
    );

    this.sectionSurgeonRequestsCounter = this.surgeonRequestsCounterAccessOption?.section ?? '';
    this.pageTitleSurgeonRequestsCounter = this.surgeonRequestsCounterAccessOption?.pageTitle ?? '';

    const sectionsMapMain = new Map<string, AccessOptions[]>();
    const sectionsMapConfig = new Map<string, AccessOptions[]>();

    accessOptionsMain.forEach((accessOption: AccessOptions) => {
      const section = accessOption.section;
      if (section) {
        if (!sectionsMapMain.has(section)) {
          sectionsMapMain.set(section, []);
        }
        sectionsMapMain.get(section)?.push(accessOption);
      }
    });

    accessOptionsConfig.forEach((accessOption: AccessOptions) => {
      const section = accessOption.section;
      if (section) {
        if (!sectionsMapConfig.has(section)) {
          sectionsMapConfig.set(section, []);
        }
        sectionsMapConfig.get(section)?.push(accessOption);
      }
    });

    for (const [section, pagesInSection] of sectionsMapMain.entries()) {
      const sortedPages = [...pagesInSection].sort(
        (a: AccessOptions, b: AccessOptions) => (a.pagePriority ?? 99) - (b.pagePriority ?? 99)
      );

      const mainItem = sortedPages[0];

      const itemEntry: any = {
        pageTitle: section,
        icon: {
          default: mainItem.iconSideNav,
          lightTheme: mainItem.iconSideNav,
        },
        link: mainItem.pageUrl,
        neededOptions: [],
        whoCanSee: ['ALL'],
      };

      const subMenus = [
        {
          title: section ?? '',
          items: sortedPages.map((page: AccessOptions) => ({
            pageTitle: page.pageTitle ?? '',
            icon: {
              default: page.iconSideNav ?? '',
              lightTheme: page.iconSideNav ?? '',
            },
            link: page.pageUrl ?? '',
            neededOptions: [],
            whoCanSee: ['ALL'],
          })),
        },
      ];

      this.pages.push({
        items: [itemEntry],
        subMenus,
      });
    }

    for (const [section, pagesInSection] of sectionsMapConfig.entries()) {
      const sortedPages = [...pagesInSection].sort(
        (a: AccessOptions, b: AccessOptions) => (a.pagePriority ?? 99) - (b.pagePriority ?? 99)
      );

      const mainItem = sortedPages[0];

      const itemEntry: any = {
        pageTitle: section,
        icon: {
          default: mainItem.iconSideNav,
          lightTheme: mainItem.iconSideNav,
        },
        link: mainItem.pageUrl,
        neededOptions: [],
        whoCanSee: ['ALL'],
      };

      const subMenus = [
        {
          title: section ?? '',
          items: sortedPages.map((page: AccessOptions) => ({
            pageTitle: page.pageTitle ?? '',
            icon: {
              default: page.iconSideNav ?? '',
              lightTheme: page.iconSideNav ?? '',
            },
            link: page.pageUrl ?? '',
            neededOptions: [],
            whoCanSee: ['ALL'],
          })),
        },
      ];

      this.pagesConfig.push({
        items: [itemEntry],
        subMenus,
      });
    }
  }

  setCurrentPage(urlArg: string | undefined = undefined) {
    const url = (urlArg || this.router.url).split('?')[0];
    const current: string[] = url.split('/');

    if (current.length <= 1) {
      return;
    }

    //take the first three segments from URL, starting from index 1
    const [segment1, segment2, segment3] = current.slice(1);

    const currentMenuAccessOptions = this.userService.getAccessOptionsOfPage(url);

    this.currentMenu = currentMenuAccessOptions?.menu ?? 'main';

    if (segment1 === 'pending-requests' && segment2 === 'home') {
      this.currentPage = '/home';
      return;
    }

    switch (segment1) {
      case 'hrsuite': {
        if (segment2 === 'demande-rh') {
          this.currentPage = 'hrsuite/demande-rh';
        } else if (segment2 === 'liste') {
          this.currentPage = 'liste';
        } else if (segment2 === 'campaigns') {
          this.currentPage = 'hrsuite/campaigns';
        } else if (segment2 === 'besoinsgarde' || segment2 === 'simpledayneeds') {
          this.currentPage = 'besoinsgarde';
        } else if (segment2 === 'stats-rh') {
          this.currentPage = 'hrsuite/stats-rh';
        }
        break;
      }
      case 'operatingschedule': {
        if (segment3 === 'profile') {
          this.currentPage = 'operatingschedule/Chirurgien/profile';
        } else {
          this.currentPage = 'operatingschedule';
        }
        break;
      }
      case 'smart-planning': {
        this.currentPage = pages.smartPlanning;
        break;
      }
      case 'profiles': {
        this.currentPage = 'hrsuite/liste';
        break;
      }
      case 'parcours-ibode': {
        if (segment3 === 'competence-individuelle') {
          this.currentPage = 'competence-individuelle';
        } else if (segment2 === 'contenu') {
          this.currentPage = 'contenu';
        } else if (segment3 === 'tableau-competences') {
          this.currentPage = 'tableau-competences';
        } else {
          this.currentPage = 'parcours-ibode';
        }
        break;
      }
      case 'statop': {
        if (segment2 === 'bloc') {
          this.currentPage = segment3 === 'general' ? 'statop/bloc/general' : 'statop/bloc/par-praticien';
        } else if (segment2 === 'anesthesiste') {
          if (segment3 === 'turnover') {
            this.currentPage = 'statop/anesthesiste/turnover';
          } else {
            this.currentPage =
              segment3 === 'general' ? 'statop/anesthesiste/general' : 'statop/anesthesiste/par-anesthesiste';
          }
        }
        break;
      }
      case 'configuration': {
        const cleanUrl = url.split('?')[0];
        // Remove last segment if it's a MongoDB ObjectId (24 hex chars)
        const segments = cleanUrl.split('/');
        const lastSegment = segments[segments.length - 1];
        if (/^[a-f\d]{24}$/i.test(lastSegment)) {
          segments.pop();
        }

        if (segments.includes('general')) {
          this.currentPage = 'general';
        } else if (segments.includes('profiles')) {
          this.currentPage = 'profiles';
        } else {
          this.currentPage = segments[segments.length - 1];
        }
        break;
      }

      default: {
        if (segment1) {
          this.currentPage = '/' + segment1;
        }
      }
    }
  }

  setDynamicPages(): void {
    this.dynamicPages = [
      pages.profiles,
      pages.parProfile,
      pages.statopAnesthesisteParAnesthesiste,
      pages.statopBlocParPraticien,
      pages.jobDescription,
      pages.jobDescription + '/individual',
      pages.indivdualCalendar,
    ];
  }

  isPageActive(link: string): boolean {
    const normalizedCurrent = normalizeUrl(this.router.url, ['/current', '/individual', /\/[a-f0-9]{24}/gi]);
    const normalizedTarget = normalizeUrl(link, ['/current', '/individual', /\/[a-f0-9]{24}/gi]);

    return normalizedCurrent === normalizedTarget;
  }

  isBesoinsGarde(): boolean {
    return this.router.url.startsWith('/hrsuite/simpledayneeds') || this.router.url.startsWith('/hrsuite/besoinsgarde');
  }

  async ngOnInit() {
    this.initProfilePictureListener();
    this.initHospitalLogoListener();
    this.getCurrentUser();
    this.setCurrentPage();
    this.setDynamicPages();
    this.isAnesth = await this.userService.isUserInAnesthesistes();
    this.getUnseenMessagesNum();
    this.getUnseenNotificationsCounter();
    this.getMessageSeenNum();
    this.inGlobalNewChannel();
    this.getSendBoxMessages();
    this.getGlobalNewMessages();
    this.getNumberOfCR();
    this.getNumberOfSurgeonRequests();

    this.isMultiHospitals = this.userService.isCurrentUserHasMultipleHospitals();
    if (this.isMultiHospitals) {
      this.checkSoloHospitalPage();
      this.getChangedHospitalsSelected();
      this.changeHospitalModeSubject();
    }

    this.getUserHospitals();
    await this.initFormationGroups();
    this.listenUpdateNumberOfCR();
    this.listenUpdateNumberOfSR();
  }

  ngAfterViewInit() {
    // This variable allows to avoid the panel to expand at the connexion
    setTimeout(() => {
      this.initDone = true;
    }, 0);
  }

  initProfilePictureListener() {
    this.subscriptionManager
      .createRequest(
        this.storageService.profilePictureInLocalStorageSubject,
        'profilePictureInLocalStorage',
        this.instanceId
      )
      .subscribe({
        next: (profilePicture: string) => {
          this.currentUserImage = profilePicture;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  initHospitalLogoListener(): void {
    this.storageService.onHospitalLogoChange((hospitalName: string, busted: string) => {
      this.hospitals = this.hospitals.map((h: Hospital) =>
        String(h.hospitalName) === String(hospitalName) ? { ...h, logoUrl: busted } : h
      );

      if (Array.isArray(this.selectedHospitals)) {
        this.selectedHospitals = this.selectedHospitals.map((h: Hospital) =>
          String(h.hospitalName) === String(hospitalName) ? { ...h, logoUrl: busted } : h
        );
      } else if (
        this.selectedHospitals &&
        String((this.selectedHospitals as any).hospitalName) === String(hospitalName)
      ) {
        this.selectedHospitals = { ...(this.selectedHospitals as Hospital), logoUrl: busted };
      }

      this.storageService.updateUserHospitalLogo(hospitalName, busted);
    });
  }

  checkSoloHospitalPage() {
    const currentUrl = this.router.url;
    const soloPages = [
      'configuration/advanced',
      'configuration/general',
      'configuration/structure',
      'configuration/rh',
      'configuration/besoins',
      'configuration/besoinsgarde',
      'configuration/tvo',
      'configuration/fiche-poste',
      'parcours-ibode',
      'smart-planning/week-vue',
      'smart-planning/my_program',
      'messagerie',
      'besoins',
      'besoinsgarde',
      'simpledayneeds',
      'Chirurgien/par-salles',
      'Chirurgien/par-interventions',
      'commission-regulation',
    ];

    if (currentUrl.includes('tableau')) {
      this.soloHospitalMode = false;
    } else if (soloPages.some((v: string) => currentUrl.includes(v))) {
      this.soloHospitalMode = true;
    }
  }

  changeHospitalModeSubject() {
    this.subscriptionManager
      .createRequest(this.userService.soloHospitalModeSubject, 'soloHospitalMode', this.instanceId)
      .subscribe({
        next: (val: any) => {
          let selectedHospitals = this.selectedHospitals;
          let selectedHospitalId = '';
          if (val == true) {
            if (Array.isArray(this.selectedHospitals)) {
              selectedHospitals = this.selectedHospitals[0];
              selectedHospitalId = this.selectedHospitals[0].id;
            }
          } else {
            selectedHospitals.selected = true;
            selectedHospitalId = selectedHospitals.id;
            selectedHospitals = [selectedHospitals];
          }
          this.hospitals.forEach((hospital: any) => {
            if (hospital.id === selectedHospitalId) {
              hospital.selected = true;
            } else {
              hospital.selected = false;
            }
          });
          this.soloHospitalMode = val;
          this.selectedHospitals = selectedHospitals;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  getChangedHospitalsSelected() {
    this.subscriptionManager
      .createRequest(this.userService.changedHospitalsSelectedSubject, 'changedHospitalsSelected', this.instanceId)
      .subscribe({
        next: () => {
          const selectedHospitals = [...this.userService.getSelectedHospitals()];
          const userHospitals = [...(this.userService.usersHospitals ?? [])];
          const principalHospitalId = this.userService.getUserPrincipalHospitalId();

          const hospitals: any = [];
          let selectedHospitalsName = '';
          this.selectedHospitals = [];
          userHospitals.forEach((hospital: Hospital) => {
            //pick up the stored logo version
            const ver = this.storageService.getHospitalLogoVersion(hospital.hospitalName || '');
            //add version to the URL to force the browser to reload the updated logo
            const busted = hospital.logoUrl ? `${hospital.logoUrl}?v=${ver}` : '';
            if (selectedHospitals.includes(hospital._id)) {
              if (hospital._id === principalHospitalId) {
                hospitals.unshift({
                  name: hospital.name,
                  id: hospital._id,
                  hospitalName: hospital.hospitalName,
                  logoUrl: busted,
                  selected: true,
                });
              } else {
                hospitals.push({
                  name: hospital.name,
                  id: hospital._id,
                  hospitalName: hospital.hospitalName,
                  logoUrl: busted,
                  selected: true,
                });
              }
              if (selectedHospitalsName.length > 0) {
                selectedHospitalsName += ', ';
              }
              selectedHospitalsName += hospital.name;
            }
          });
          if (!this.soloHospitalMode) {
            this.selectedHospitals = hospitals;
          } else {
            this.selectedHospitals = hospitals[0];
          }
          this.selectedHospitalsName = selectedHospitalsName;

          this.getUnseenNotificationsCounter();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  compareCategoryObjects(object1: any, object2: any) {
    return object1 && object2 && object1.id == object2.id;
  }

  getUserHospitals() {
    const hospitals = [...(this.userService.usersHospitals ?? [])];
    const lastSelectedHospitals = this.userService.getSelectedHospitals();
    const principalHospitalId = this.userService.getUserPrincipalHospitalId();
    const allHospitalNames = hospitals.map((h) => h.hospitalName);
    const hasMultipleHospitalNames = new Set(allHospitalNames).size > 1;

    hospitals.forEach((hospital: any) => {
      const ver = this.storageService.getHospitalLogoVersion(hospital.hospitalName || '');
      const busted = hospital.logoUrl ? `${hospital.logoUrl}?v=${ver}` : '';

      if (hospital._id === principalHospitalId) {
        this.hospitals.unshift({
          name: hospital.name,
          id: hospital._id,
          hospitalName: hospital.hospitalName,
          logoUrl: busted, //keep the logoUrl to display it
          selected: false,
          hasMultipleHospitalNames,
          displayName: hospital.displayName,
        });
      } else {
        this.hospitals.push({
          name: hospital.name,
          id: hospital._id,
          hospitalName: hospital.hospitalName,
          logoUrl: busted,
          selected: false,
          displayName: hospital.displayName,
        });
      }
    });

    if (lastSelectedHospitals.length === 0) {
      this.hospitals[0].selected = true;
      if (!this.soloHospitalMode) {
        this.selectedHospitals = [this.hospitals[0]];
      } else {
        this.selectedHospitals = this.hospitals[0];
      }
      this.selectedHospitalsName = this.hospitals[0].name;
    } else {
      const selectedHospitals: any = [];
      let selectedHospitalsName = '';
      this.nbSelectedHospitals = 0;
      this.hospitals.forEach((hospital: any) => {
        if (lastSelectedHospitals.includes(hospital.id)) {
          hospital.selected = true;
          selectedHospitals.push(hospital);
          this.nbSelectedHospitals++;
          if (selectedHospitalsName.length > 0) {
            selectedHospitalsName += ', ';
          }
          selectedHospitalsName += hospital.name;
        }
      });
      if (!this.soloHospitalMode) {
        this.selectedHospitals = selectedHospitals;
        this.selectedHospitals[0].selected = true;
      } else {
        this.selectedHospitals = selectedHospitals[0];
        this.selectedHospitals.selected = true;
      }
      this.selectedHospitalsName = selectedHospitalsName;
    }
  }

  /**
   * Close the right clicked menu
   */
  closeRightClickedMenu() {
    if (this.rightClickBtnContainer && document.activeElement !== this.rightClickBtnContainer.nativeElement) {
      this.rightClickedPage = null;
    }
  }

  /**
   * Open the link in a new tab
   */
  openNewTab() {
    window.open(this.rightClickedPage.link);
  }

  /**
   * Open the link in a new window
   */
  openNewWindow() {
    // window's dimensions
    const width = window.innerWidth;
    const height = window.innerHeight;
    const pageLink = this.rightClickedPage.link;

    // Open window
    window.open(pageLink, '_blank', `width=${width},height=${height}`);
  }

  onChangeHospital(event: any) {
    const hospitalIds: any = [];
    this.selectedHospitals = event;

    if (!this.soloHospitalMode) {
      let count = 0;
      event.forEach((element: any) => {
        hospitalIds.push(element.id);
        count++;
      });
      this.nbSelectedHospitals = count;
      let selectedHospitalsName = '';
      this.hospitals.forEach((hospital: any) => {
        hospital.selected = false;
      });
      event.forEach((element: any) => {
        const hospital = this.hospitals.find((hospital: any) => hospital.id == element.id);

        hospital.selected = true;

        if (hospital) {
          if (selectedHospitalsName.length > 0) {
            selectedHospitalsName += ', ';
          }
          selectedHospitalsName += hospital.name;
        }
      });
      this.selectedHospitalsName = selectedHospitalsName;
      this.storageService.saveData('selectedHospitalsId', hospitalIds);
    } else {
      this.nbSelectedHospitals = 1;
      this.selectedHospitalsName = event.name;
      this.storageService.saveData('selectedHospitalsId', [event.id]);
    }

    this.getUnseenNotificationsCounter();
    this.navigationService.reloadCurrentRoute();
    this.taskService.triggerReload();
  }

  navigateToHome() {
    this.navigationService.navigateTo(this.realHomePage?.pageUrl ?? '', null, false);
  }

  getUnseenNotificationsCounter() {
    if (this.currentUser?.profile?._id) {
      this.subscriptionManager
        .createRequest(
          this.notificationService.getNotificationsCounter(this.currentUser.profile._id),
          'getNotificationsCounter',
          this.instanceId
        )
        .subscribe({
          next: (res: any) => {
            this.notificationsCounter = res;
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }
  }

  inGlobalNewChannel() {
    this.subscriptionManager
      .createRequest(this.chatService.inGlobalNewChannelSubject, 'inGlobalNewChannel', this.instanceId)
      .subscribe({
        next: (res: any) => {
          if (!_.isEmpty(res)) {
            this.unseenMessages++;
          }
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  getUnseenMessagesNum() {
    this.subscriptionManager
      .createRequest(this.chatService.unseenMessagesSubject, 'unseenMessages', this.instanceId)
      .subscribe({
        next: (res: any) => {
          this.unseenMessages = res;
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  getMessageSeenNum() {
    this.subscriptionManager
      .createRequest(this.chatGlobalSocket.messageSeenNumSubject, 'messageSeenNum', this.instanceId)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.unseenMessages = this.unseenMessages - res;
          }
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  getSendBoxMessages() {
    this.subscriptionManager
      .createRequest(this.chatGlobalSocket.sendBoxMessagesSubject, 'sendBoxMessages', this.instanceId)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.unseenMessages++;
          }
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  getGlobalNewMessages() {
    this.subscriptionManager
      .createRequest(this.chatService.globalNewMessagesSubject, 'globalNewMessages', this.instanceId)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.unseenMessages = this.unseenMessages + res;
          }
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  getCurrentUser(): void {
    this.currentUser = this.storageService.getUser();
    if (this.currentUser && this.currentUser.profile && this.currentUser.profile.profilePic) {
      this.currentUserImage = this.currentUser.profile.profilePic;
    } else {
      this.onAvatarErrorComponent();
    }

    this.currentUserName = this.getCurrentUserName();
  }

  getCurrentUserName() {
    let name =
      this.currentUser && this.currentUser.profile
        ? `${capitalize(this.currentUser?.profile?.firstName ?? '')} ${(this.currentUser?.profile?.lastName ?? '').charAt(0)}.`
        : '';

    if (this.sideNavReduced) {
      name =
        this.currentUser && this.currentUser.profile
          ? `${(this.currentUser.profile.firstName ?? '').charAt(0)}. ${(this.currentUser.profile.lastName ?? '').charAt(0)}.`
          : '';
    }
    return name;
  }

  getAuthorizedPage(items: any[]) {
    const authorizedPage = items.filter((item: any) => this.isAllowToAccessToItem(item));
    return authorizedPage[0];
  }

  async initFormationGroups(): Promise<void> {
    const [nursesFormationsTmp, anesthsFormationsTmp, iadesFormationsTmp, cdbFormationsTmp, surgeonsFormationsTmp] =
      await Promise.all([
        this.userService.getFormationsByGroupName(undefined, 'NURSES'),
        this.userService.getFormationsByGroupName(undefined, 'ANESTHESISTES'),
        this.userService.getFormationsByGroupName(undefined, 'IADES'),
        this.userService.getFormationsByGroupName(undefined, 'CDB'),
        this.userService.getFormationsByGroupName(undefined, 'SURGEONS'),
      ]);
    this.nursesFormations = nursesFormationsTmp.map((formation: any) => formation.name);
    this.anesthsFormations = anesthsFormationsTmp.map((formation: any) => formation.name);
    this.iadesFormations = iadesFormationsTmp.map((formation: any) => formation.name);
    this.cdbFormations = cdbFormationsTmp.map((formation: any) => formation.name);
    this.surgeonsFormations = surgeonsFormationsTmp.map((formation: any) => formation.name);
  }

  onAvatarErrorComponent(): void {
    let picture: string;
    if (this.nursesFormations.includes(this.currentUser?.profile?.position ?? '')) {
      picture = 'assets/images/icons/nurse.svg';
    } else if (
      this.surgeonsFormations.includes(this.currentUser?.profile?.position ?? '') ||
      this.cdbFormations.includes(this.currentUser?.profile?.position ?? '')
    ) {
      picture = 'assets/images/icons/surgeon.svg';
    } else if (
      this.anesthsFormations.includes(this.currentUser?.profile?.position ?? '') ||
      this.iadesFormations.includes(this.currentUser?.profile?.position ?? '')
    ) {
      picture = 'assets/images/icons/f-doctor.svg';
    } else {
      picture = 'assets/images/icons/surgeon.svg';
    }

    this.currentUserImage = picture;
  }

  goToMyAccount() {
    this.subscriptionManager.createRequest(this.goToNextEvent(), 'goToMyAccount', this.instanceId).subscribe({
      next: (res: any) => {
        if (res === false) {
          this.saveAgendas.emit(true);
        } else if (res === true) {
          this.navigationService.navigateTo(pages.profile, null, false);
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
  }

  isAllowToAccessToItem(item: any) {
    const neededOptions = item.neededOptions ? item.neededOptions : [];

    for (const neededOption of neededOptions) {
      if (!this.hospitalService.checkIfHospitalHaveOption(neededOption)) {
        return false;
      }
    }

    return true;
  }

  displaySubMenus(page: any) {
    if (!page.subMenus || !page.subMenus.find((subMenu: any) => subMenu.items.length > 1)) {
      return false;
    } else {
      let result = false;
      page.subMenus.forEach((subMenu: any) => {
        result = result || this.displaySubMenu(subMenu);
      });
      return result;
    }
  }

  displaySubMenu(subMenu: any) {
    let result = false;
    subMenu.items.forEach((item: any) => {
      result = result || this.isAllowToAccessToItem(item);
    });
    return result;
  }

  onLogout() {
    this.storageService.saveData('isDisconnecting', true);
    this.router
      .navigate([pages.login])
      .then(() => {
        this.storageService.saveData('isDisconnecting', false);
        this.authenticationService.logout();
      })
      .catch((error: any) => this.errorService.handleError(error));
  }

  checkSaveBeforeLogout() {
    this.subscriptionManager.createRequest(this.goToNextEvent(), 'checkSaveBeforeLogout', this.instanceId).subscribe({
      next: (res: any) => {
        if (res === false) {
          this.saveAgendas.emit(true);
        } else if (res === true) {
          this.onLogout();
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
  }

  goToConfiguration() {
    this.subscriptionManager.createRequest(this.goToNextEvent(), 'goToConfiguration', this.instanceId).subscribe({
      next: (res: any) => {
        if (res === false) {
          this.saveAgendas.emit(true);
        } else if (res === true) {
          this.navigationService.navigateTo(this.pagesConfig[0].items[0].link, null, false);
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
  }

  onSideNavRootItemClick(page: any, event: any, isMenuActive: boolean) {
    if (!this.displaySubMenus(page) || isMenuActive) {
      return;
    }

    this.navigateToFirstAccessibleSubPage(page, event);
  }

  navigateToFirstAccessibleSubPage(page: any, event: any) {
    for (const subMenu of page.subMenus) {
      for (const pageSub of subMenu.items) {
        if (this.isAllowToAccessToItem(pageSub)) {
          this.itemSubMenuClickedHandler(event, pageSub);
          return;
        }
      }
    }
  }

  _sidenavToggle() {
    this.sideNavReduced = !this.sideNavReduced;
    this.currentUserName = this.getCurrentUserName();
    this.sidenavToggle.emit();
    this.utilisService.toggleSidenav();
    this.utilisService.isSideNavReduced.next(this.sideNavReduced);
  }

  isNotificationLink(pageTitle: string) {
    return pageTitle === 'Notifications';
  }

  goToNextEvent() {
    if (this.isThereNewModifs) {
      return this.utilisService.openUnSavedChangesPopup();
    } else {
      return new Observable((sub: any) => sub.next(true));
    }
  }

  checkSaveBeforeNavigate(event: any, page: any, isNotificationLink: boolean = true) {
    this.subscriptionManager.createRequest(this.goToNextEvent(), 'goToNextEvent', this.instanceId).subscribe({
      next: (res: any) => {
        if (res === false) {
          this.saveAgendas.emit(true);
        } else if (res === true) {
          if (this.isNotificationLink(page.pageTitle) && isNotificationLink) {
            this.subscriptionManager
              .createRequest(
                this.utilisService
                  .openPopup(NotificationsFeedComponent, {
                    panelClass: 'custom-dialog-container-without-padding',
                  })
                  .afterClosed(),
                'NotificationFeeComponentPopup',
                this.instanceId
              )
              .subscribe({
                next: () => this.getUnseenNotificationsCounter(),

                error: (error: any) => {
                  this.errorService.handleError(error);
                },
              });
          } else {
            event.stopPropagation();
            this.navigationService.navigateTo(page.link, null, false);
          }
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
  }

  itemSubMenuClickedHandler(event: any, page: any) {
    const normalizedCurrent = normalizeUrl(this.router.url, ['/current', /\/[a-f0-9]{24}/gi]);
    const normalizedTarget = normalizeUrl(page.link, ['/current', /\/[a-f0-9]{24}/gi]);

    if (normalizedCurrent === normalizedTarget) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.checkSaveBeforeNavigate(event, page, false);
  }

  navigateToMessages(event: any) {
    const page = {
      pageTitle: 'Messagerie',
      link: pages.messaging,
    };
    this.checkSaveBeforeNavigate(event, page);
  }

  navigateToNotifications(event: any) {
    posthog.capture('Show_Notifications');
    const page = {
      pageTitle: 'Notifications',
      link: '#',
    };
    this.checkSaveBeforeNavigate(event, page);
  }

  toggleSideNav() {
    this.subscriptionManager.createRequest(this.userService.sideNav, 'toggleSideNav', this.instanceId).subscribe({
      next: () => {
        this._sidenavToggle();
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
  }

  isSubMenuActive(link: string, rla: boolean) {
    if (this.currentPage === 'hrsuite/liste' && link.startsWith('/profiles')) {
      return true;
    }
    if (
      this.currentPage !== 'hrsuite/demande-rh' &&
      this.currentPage !== 'liste' &&
      this.currentPage !== 'hrsuite/campaigns' &&
      this.currentPage !== 'statop/anesthesiste/par-anesthesiste' &&
      this.currentPage !== 'statop/bloc/par-praticien' &&
      this.currentPage !== 'statop/anesthesiste/turnover' &&
      this.currentPage !== 'competence-individuelle' &&
      this.currentPage !== 'contenu' &&
      this.currentPage !== 'operatingschedule/Chirurgien/profile' &&
      this.currentPage !== 'tableau-competences'
    ) {
      return rla;
    } else if (this.currentPage === 'tableau-competences') {
      const accessOptionTableauCompetences = (
        (this.userService.getCurrentUser().persona as Personas).accessOptions as AccessOptions[]
      ).find(
        (accessOption: AccessOptions) => accessOption.pageUrl === '/parcours-ibode/competence/tableau-competences'
      );
      if (accessOptionTableauCompetences?.displayInSideNav) {
        return link === '/parcours-ibode/competence/tableau-competences';
      } else {
        return link === '/parcours-ibode/competence' ? true : false;
      }
    } else {
      return link.includes(this.currentPage);
    }
  }

  isMenuActive(page: any) {
    for (const subMenu of page.subMenus) {
      for (const item of subMenu.items) {
        const result = this.isMenuLinkActif(item.link);
        if (result) {
          return true;
        }
      }
    }
    return false;
  }

  isMenuLinkActif(link: string) {
    if (this.currentPage === 'tableau-competences') {
      return link === '/parcours-ibode/competence' ? true : false;
    } else if (this.currentPage && this.currentPage !== '/profile') {
      // Multiple tabs share /hrsuite/demande-rh as a common base: match any tab URL
      if (this.currentPage === 'hrsuite/demande-rh' && link.startsWith('/hrsuite/demande-rh')) {
        return true;
      }
      const urlWithoutParams = this.router.url.split('?')[0];
      const normalizedCurrent = normalizeUrl(urlWithoutParams, [/\/[a-f0-9]{24}/gi, /\/individual\/[a-f0-9]{24}/gi]);
      const normalizedLink = normalizeUrl(link, [/\/[a-f0-9]{24}/gi, /\/individual\/[a-f0-9]{24}/gi]);
      return normalizedCurrent === normalizedLink || normalizedCurrent.startsWith(normalizedLink);
    } else {
      return false;
    }
  }

  subscribeToReloadActiveRequestsCounterSubject(): void {
    this.subscriptionManager
      .createRequest(
        this.hrsuiteService.reloadActiveRequestsCounterSubject,
        'subscribeToReloadActiveRequestsCounterSubject',
        this.instanceId
      )
      .subscribe({
        next: () => {
          this.getNumberOfCR();
          this.getNumberOfSurgeonRequests();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  // gestion isNight
  subscribeTotoggleNightHRRequestsSubject() {
    this.subscriptionManager
      .createRequest(this.hrsuiteService.toggleNightSubject, 'subscribeTotoggleNightHRRequestsSubject', this.instanceId)
      .subscribe({
        next: () => {
          this.getNumberOfCR();
          this.getNumberOfSurgeonRequests();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  listenUpdateNumberOfCR() {
    this.subscriptionManager
      .createRequest(this.hrsuiteService.updateNumberOfCR$, 'listenUpdateNumberOfCR', this.instanceId)
      .subscribe({
        next: async (formationsNames: string[] | undefined) => {
          if (Array.isArray(formationsNames) && formationsNames.length) {
            this.counterFormations = formationsNames;
          }
          await this.getNumberOfCR();
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  async getNumberOfCR() {
    const formations =
      this.counterFormations.length > 0
        ? this.counterFormations
        : (
            await this.userService.getAccessOptionsPositionsByPositions(this.requestsCounterAccessOption?.positions)
          ).map((formation: Formation) => formation.name);

    this.subscriptionManager
      .createRequest(
        this.calendarRequestService.getActiveRequestsCounter(
          formations.join(','),
          this.requestsCounterAccessOption?.seniority
            ? this.requestsCounterAccessOption.seniority.join(',')
            : undefined,
          true
        ),
        'getNumberOfCR',
        this.instanceId,
        false,
        2000
      )
      .subscribe({
        next: (res: any) => {
          this.requestsCounter = res?.total;
        },
        error: (error: any) => this.errorService.handleError(error),
      });
  }

  listenUpdateNumberOfSR() {
    this.subscriptionManager
      .createRequest(this.calendarRequestService.updateRequestNumber$, 'listenUpdateNumberOfSR', this.instanceId)
      .subscribe({
        next: async (res: number) => {
          this.surgeonRequestsCounter = res;
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  async getNumberOfSurgeonRequests() {
    const formations = (
      await this.userService.getAccessOptionsPositionsByPositions(this.surgeonRequestsCounterAccessOption?.positions)
    ).map((formation: Formation) => formation.name);

    this.subscriptionManager
      .createRequest(
        this.calendarRequestService.getActiveRequestsCounter(formations.join(','), undefined, true),
        'getNumberOfSurgeonRequests',
        this.instanceId,
        false,
        2000
      )
      .subscribe({
        next: (res: any) => {
          this.surgeonRequestsCounter = res?.total;
          this.calendarRequestService.updateUpdateRequestNumberSubject(true, res?.total || 0);
        },
        error: (error: any) => this.errorService.handleError(error),
      });
  }

  openProfileSearch() {
    this.dialog.open(AnnuairePopupComponent, {
      width: '75%',
      height: '80%',
      panelClass: 'annuaire-popup',
      data: {
        title: 'Recherche un profil',
      },
    });
  }

  ngOnDestroy() {
    if (this.sideNavReduced) {
      this.sidenavToggle.emit();
    }
  }
}
